import { useRef } from 'react'
import PropTypes from 'prop-types'
import { ListBox } from 'primereact/listbox'

import OverlayPanel from '@aytm/app/stats/components/overlay-panel/OverlayPanel'

import { useChartModeOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/components/chart-modes/hooks/useChartModeOptions'

import style from '@aytm/app/stats/page/question-views/components/charts/highcharts/components/chart-modes/styles/ChartModes.module.scss'

const itemTemplate = option => (
  <div className={style.item}>
    <i className={`icon-aytmfd-${option.icon}`} />
    <span className={style['item-text']}>{option.text}</span>
  </div>
)

const ChartModes = ({
  chartModeTypes,
  chartModeOptions,
  withDefault = true,
  chartMode,
  chartModeOverride,
  globalChartMode,
  onChange
}) => {
  const ref = useRef(null)
  const { options, currentIcon, selectedChartMode } = useChartModeOptions({
    chartModeTypes,
    chartModeOptions,
    withDefault,
    chartMode,
    chartModeOverride,
    globalChartMode
  })

  const handleChange = event => {
    ref.current?.hide()
    onChange(event.value)
  }

  return (
    <div className={style['chart-modes']}>
      <OverlayPanel
        ref={ref}
        testId="stat-chart-modes-button"
        panelClassName={style.panel}
        button={
          <div className={style.button}>
            <i className={`icon-aytmfd-${currentIcon}`} />
            <span className={style.arrow} />
          </div>
        }
      >
        <ListBox
          className="p-listbox-no-scroll"
          value={selectedChartMode}
          options={options}
          optionLabel="text"
          optionValue="key"
          onChange={handleChange}
          itemTemplate={itemTemplate}
        />
      </OverlayPanel>
    </div>
  )
}

ChartModes.propTypes = {
  chartModeTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  chartModeOptions: PropTypes.object,
  withDefault: PropTypes.bool,
  chartMode: PropTypes.string.isRequired,
  chartModeOverride: PropTypes.string,
  globalChartMode: PropTypes.string,
  onChange: PropTypes.func.isRequired
}

export default ChartModes
